// eslint-disable-next-line import/no-cycle
import * as globalApi from '@/api/global'
import { Message } from '@qs/ui'
import Layout from '@/layouts/Layout'
// import Page404 from '@/pages/404.vue'
import { cloneDeep } from 'lodash'
import { flatFun } from '@/utils'
import domainRouter from '@/router/domain'

const flatRouterMapper = new Map()
const flatRouterArray = []
function flatRouters(routers, mapper = new Map(), arr = []) {
  routers.forEach((element) => {
    if (!element.name) return
    const obj = {
      path: element.path,
      name: element.name,
      component: element.component,
      hidden: element.hidden,
      meta: element.meta,
    }
    arr.push(obj)
    mapper.set(element.name, obj)
    if (element.children && element.children.length > 0) {
      flatRouters(element.children, mapper, arr)
    }
  })
}

const logo =
  'https://cdn.cheweijia.com/public/96c9b4f9b17e4257b5f3d54454072cb2.png'

const permission = {
  state: {
    resourceList: [],
    subMenuList: [], // 左侧二级菜单栏目
    navMenus: [], // 左侧一级菜单栏目
    asynRouters: null,
    addRouters: [], // 动态路由数据
    isGetPermission: true, // 资源加载中
    pathnames: [], // 平台权限
    logoText: '',
    logo: '',
    menus: {},
    allResource: [],
  },
  mutations: {
    SET_ALLRESOURCE: (state, allResource) => {
      state.allResource = allResource
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
    },
    SET_ASYN_ROUTERS: (state, routers) => {
      state.asynRouters = routers
    },
    SET_GET_IS_PERMISSION(state, flan) {
      state.isGetPermission = flan
    },
    SET_PLATFORM(state, pathnames) {
      state.pathnames = pathnames
    },
    // 左侧一级菜单栏目
    SET_NAV_MENU(state, navMenus) {
      state.navMenus = navMenus
    },
    SET_RESOURCE_LIST(state, resourceList) {
      state.resourceList = resourceList
    },
    // logo 只有顶部用 稍后优化
    SET_LOGO_OBJ: (state, data = {}) => {
      const { logoText = logo } = data
      state.logoText = logoText
      state.logo = data.logo || require('../../assets/img/logo.svg')
      const link = document.getElementsByTagName('link')
      for (const i in link) {
        const li = link[i]
        if (li.rel === 'shortcut icon') {
          li.href = data.favicon
          li.type = 'image/x-icon'
          break
        }
      }
    },
    // 左侧二级菜单栏目
    SET_DYNAMIC_ROUTE(state, subMenuList) {
      state.subMenuList = subMenuList
    },
    SET_MENUS(state, menus) {
      state.menus = menus
    },
  },
  actions: {
    async getResourceByToken({ commit, getters, dispatch }, params = {}) {
      const { baseName } = params
      commit('SET_GET_IS_PERMISSION', true)
      globalApi
        .getTenantLogo()
        .then((res) => {
          commit('SET_LOGO_OBJ', res.data || {})
        })
        .catch(() => {
          commit('SET_LOGO_OBJ', {})
        })

      return new Promise((resolve, reject) => {
        globalApi
          .getResourceByTokenV2({
            ...params,
            businessGroup: 'vehicle_web',
            groupName: 'vehicle',
          })
          .then(async (res) => {
            const allResource = ['tenant_finance_costcenter']
            flatRouters(domainRouter, flatRouterMapper, flatRouterArray)
            commit('SET_ALLRESOURCE', allResource)
            const _data = copy(res?.data || [], null, allResource)
            let { resData } = _data
            const { globalFilter = false, globalFilterRes = {} } = params
            const blackList = globalFilterRes.blackList || []
            if (globalFilter === true && blackList.length > 0) {
              resData = filterByBlackList(
                resData,
                blackList.map((o) => o.id),
              )
            }
            const adminRoutes = [
              '2019nCoVLoveListCfg',
              'activitylist-taskDetail',
            ]
            // 租牌需求前账号可管理全部城市 adCodeList = [], 租牌需求上线全部城市用 ALL 值表示，
            // 所以此处做兼容处理，adCodeList.length = 0 或者 adCodeList 包含 ALL 值，及代表是 admin 用户。
            // （服务租户上线时也同样做兼容处理）
            const isAdmin =
              getters.userInfo &&
              getters.userInfo.adCodeList &&
              (!getters.userInfo.adCodeList.length ||
                getters.userInfo.adCodeList.includes('ALL'))
            if (!isAdmin && getters.userInfo.userType === 1) {
              resData = filterNoAdminKeys(resData, adminRoutes)
            }
            commit('SET_RESOURCE_LIST', resData) // 缓存资源权限

            // 获取 一级导航
            const { navMenu } = _data
            if (!navMenu || !navMenu.length) {
              Message.warning('当前账号无资源权限访问，请联系管理员！')
              dispatch('FedLogOut')
              reject('无权限访问')
            }

            // 获取路由 通过 接口返回的资源树
            const filterRouter = createRoutesByAuthenticTree(resData, 1)
            const { pathnameList } = getPlatformRole(resData, baseName)
            commit('SET_PLATFORM', pathnameList)

            // 面包屑逻辑 稍后优化
            const menus = {}
            getMenus(resData, menus)
            commit('SET_MENUS', menus)
            commit('SET_NAV_MENU', navMenu) // 左侧一级导航

            commit('SET_ROUTERS', filterRouter)
            commit('SET_GET_IS_PERMISSION', false)
            resolve(res)
          })
          .catch((err) => {
            commit('SET_GET_IS_PERMISSION', false)
            reject(err)
          })
      })
    },
    // 变更二级菜单
    async changeMenu({ commit, state }, { platformName } = {}) {
      const navMenu = state.navMenus.find((item) => item.key === platformName)
      commit('SET_DYNAMIC_ROUTE', navMenu?.subList || [])
    },
  },
}
/**
 * 根据云控资源黑名单过滤资源数据
 * @param {*} data
 * @param {*} blackIds
 */
function filterByBlackList(data = [], blackIds = []) {
  let filterRes = data
  filterRes = filterRes.filter((o) => {
    const { id, subList = [] } = o
    if (!blackIds.includes(id)) {
      if (subList && subList.length) {
        o.subList = filterByBlackList(subList, blackIds)
      }
      return true
    }
    return false
  })
  return filterRes
}
// 获取平台权限 & 当前平台资源
function getPlatformRole(roles, platformName) {
  const roleList = [...roles]
  let role = []
  const pathnameList = []
  for (const i in roleList) {
    if (roleList[i].resourceKey === platformName) {
      // 当前平台的资源
      role = roleList[i].subList
    }
    pathnameList.push(roleList[i].resourceKey) // 平台权限集合
  }
  return { role, pathnameList }
}
// 过滤非全部城市的resourceKey
function filterNoAdminKeys(data = [], blackKeys = []) {
  let filterRes = data
  filterRes = filterRes.filter((o) => {
    const { resourceKey, subList = [] } = o
    if (!blackKeys.includes(resourceKey)) {
      if (subList && subList.length) {
        o.subList = filterNoAdminKeys(subList, blackKeys)
      }
      return true
    }
    return false
  })
  return filterRes
}

// 直接通过树结构进行渲染路由树 不依赖本地路由文件
// resourceList ==》 treeData
// whitelists ==> 未来的白名单
const pagesContext = require.context('@/pages', true, /\.vue$/)

const loadView = (path) => {
  let component = null
  const reg = /\.vue$/
  try {
    const viewPath = reg.test(`${path}`) ? `.${path}` : `.${path}/index.vue`
    // 尝试加载组件
    component = pagesContext(viewPath)
      ? pagesContext(viewPath).default
      : null
      // : Page404
  } catch (e) {
    component = null
  }
  // 生成组件的命名路径
  return component
}
function getRouteComponent(resourceKey, resourceType, path) {
  // 其实应该是优先判断没有path
  if (flatRouterMapper.has(resourceKey)) {
    return flatRouterMapper.get(resourceKey).component
  }
  return resourceType === 1 ? Layout : loadView(path)
}
function createRoutesByAuthenticTree(treeData) {
  const result = []
  // 第一层节点
  cloneDeep(treeData).forEach((node) => {
    if (Array.isArray(node.subList)) {
      node.children = []
      // 扁平化所有的子资源 key: resourceKey
      const _subList = flatFun(node.subList)
      _subList.forEach((subNode) => {
        if (flatRouterMapper.has(subNode.resourceKey)) {
          // 通过subNode.resourceKey 获取对应的路由配置 会有重复的情况 兜底
          const _routers = flatRouterArray.filter((item) => item.name === subNode.resourceKey)
          // 全部添加到路由表
          _routers.forEach((r) => {
            const newR = { ...r }
            newR.meta.title = subNode.name || r.meta.title
            node.children.push(newR)
          })
          return
        }
        // 没有在路由表中 动态判断是否存在 如若是404 就不在添加了
        const _component = getRouteComponent(
          subNode.resourceKey,
          subNode.resourceType,
          subNode?.path,
        )

        // 当不是菜单（菜单没有path） 且 组件部位空时 才添加
        if (subNode?.path && _component) {
          node.children.push({
            path: subNode.path,
            name: subNode.resourceKey,
            component: _component,
            meta: {
              title: subNode.resourceName || subNode.name,
              icon: subNode.icon,
              resourceKey: subNode.resourceKey,
              resourceType: subNode.resourceType,
              resourceId: subNode.resourceId,
              resourcePath: subNode.resourcePath,
            },
          })
        }
      })
    }

    const obj = {
      path: flatRouterMapper.get(node.resourceKey)?.path || node?.path,
      name: node?.resourceKey,
      meta: {
        ...flatRouterMapper?.get(node.resourceKey)?.meta,
        title: node?.name,
      },
      component: getRouteComponent(
        node.resourceKey,
        node.resourceType,
        node?.path,
      ),
      children: node.children,
    }
    result.push(obj)
  })
  return result
}

// 补全不存在的path
function fixedPath(route) {
  if (flatRouterMapper.has(route?.resourceKey)) {
    return flatRouterMapper.get(route?.resourceKey).path
  }

  return route.path
}

function getMenus(resourceList, result = {}, level = []) {
  cloneDeep(resourceList).forEach((resource) => {
    if (!result[resource.resourceKey] && level.length) {
      result[resource.resourceKey] = [...level]
    }

    if (resource.subList && resource.subList.length) {
      getMenus(resource.subList, result, [...level, resource.resourceKey])
    }
  })
}

function copy(data, parent = null, allResource) {
  const allResult = []
  const allMenus = []
  data?.forEach((item) => {
    if (
      item.resourceKey &&
      !allResource.includes(item.resourceKey)
    ) {
      allResource.push(item.resourceKey)
    }
    const result = {
      ...item,
      id: item.id,
      name: item.name,
      type: item.type,
      key: item.resourceKey,
      icon: item.resourceKey,
      resourceKey: item.resourceKey,
      resourceType: item.type,
      hoverIcon: `${item.resourceKey}_hover`,
      activeIcon: `${item.resourceKey}_active`,
      parent,
      rootResourceKey: item?.rootResourceKey,
      path: fixedPath(item),
    }
    // 菜单有限制 子页面和按钮不存在
    let subList = {}
    if (item.subList && item.subList.length > 0) {
      subList = copy(item.subList || [], item, allResource)
    }
    result.subList = subList?.resData

    // 如果是 子页面和按钮 是不需要在左侧菜单中显示的
    if (!(item.type === 2 && parent?.type === 2) && item.type !== 3) {
      allMenus.push({ ...result, subList: subList?.navMenu })
    }

    allResult.push(result)
  })

  return { resData: allResult, navMenu: allMenus }
}

export default permission
